export const maybeLog = (message: any) => {
  const config = useRuntimeConfig();

  if (config.public.logging == "true") {
    console.info(message);
  }
};
